var numOfTries = 3;

export async function postToServer(url, data) {
    var res = null;

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };

    for (var i = 0; i < numOfTries && (res == null || res.ok == false); i++) {
        try {
            res = await fetch(url, options);
        } catch (err) { };
    }

    if (res == null || res.ok == false)
        throw "Failled to post to server, url= " + url;

    return res;
}

export async function getFromServer(url) {
    var res = null;
    for (var i = 0; i < numOfTries && (res == null || res.ok == false); i++) {
        try {
            res = await fetch(url);
        } catch (err) { };
    }

    if (res == null || res.ok == false)
        throw "Failled to get response from server, url=" + url;

    return await res.json();
};